export default __webpack_public_path__ + "static/media/demonicheart.808aa818.png";